import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DynamicListArea,LoadGraphic,Step} from '../components/Common';
import u from '../utilities/Utilities';

export default class QuizAttemptList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Quiz Attempts",
        permission:"course",          //Accepts combined permission module as well
        //combinedField:"",   //Used when permission exists in a combined field
        url:"/quiz-attempt-list",

        /**** Action Setup ****/
        addType:0,
        deleteURL:"/api/delete-quiz-attempt-entries",
        spreadsheetURL:"/api/generate-quiz-attempt-spreadsheet",
        overviewURL:"/api/get-all-quiz-attempt-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"quiz-attempt-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index} 
                                          index={index} 
                                          content={content} 
                                          onChange={onChange} 
                                          onContentChange={onContentChange} 
                                          registerReference={registerRef} 
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    render=()=>{
        const {content,settings,permissions} = this.props;
        const canEdit= (permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel} 
                                    permission={settings.permission} 
                                    content={content} 
                                    onChange={this.props.onChange} 
                                    index={this.props.index}
                                    />

                    <div className='list-table' style={{width:"800px",margin:"30px auto"}}>
                        <h3>Questions</h3>
                        <table>
                            <thead>
                                <th className='remove left'>S/N</th>
                                <th>Question</th>
                                <th className='right' style={{width:"120px"}}>Correct/Wrong</th>
                            </thead>
                            <tbody>
                                {
                                    content.questions.map(
                                        (item,index)=>{
                                            return (
                                                <tr key={index}>
                                                    <td className='remove'>{index+1}.</td>
                                                    <td>{item.question}</td>
                                                    <td style={{width:"120px"}}>{(item.answerIndex == item.selected) ? <span>Correct</span> : <span className='text-negative'>Wrong</span>}</td>
                                                </tr>
                                            )
                                        }
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </Step>
            </div>
        )
    }
}
